import QRCode from "qrcode.react";

export default function QrLabelItem({ visitorData, item }) {
  function getData() {
    switch (item.type) {
      case "registration_code_qr":
        return visitorData?.registration_code;
      
      case "access_commander_2n_pin_qr":
        return visitorData?.external_ids?.find(
          (id) => id.name === "vis_access_commander_2n_pin"
        )?.external_id;
        
      default:
        return "";
    }
  }

  return (
    <QRCode
      value={getData()}
      style={{ width: "100%", height: "100%", objectFit: "contain" }}
    />
  );
}
